import { render, staticRenderFns } from "./EndedEventForm.vue?vue&type=template&id=789b506e&"
import script from "./EndedEventForm.vue?vue&type=script&lang=js&"
export * from "./EndedEventForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports